import React from 'react'
const initialState = {
  activeDetailProgram  : null,
  returnMapState       : null, 
  returnLocationFilter : null,
}

function init (nextState) {
  if (nextState) {
    return {
      ...initialState,
      ...nextState,
    }
  }
  return { ...initialState, }
}

/**
 * Function to set the active program when a program is selected from the sidebar.
 * 
 * @param {*} state 
 * @param {*} param1 
 * @returns 
 */
function setActiveDetailProgram (state, { program, }) {
  // If we have a program, set it.
  if (program) {
    return {
      ...state,
      activeDetailProgram: program,
    }
  }

  // If we don't, clear any existing program.
  else {
    return {
      ...state,
      activeDetailProgram: null,
    }
  }
  
}

/**
 * Function to update the active program when a program is selected from the sidebar.
 * 
 * @param {*} state 
 * @param {*} param1 
 * @returns 
 */
function activateDetailProgram (state, { program, mapState, locationFilter, }) {
  // Case 01: If you have no program information, return the current state.
  if (!program && !mapState && !locationFilter) {
    const nextState = {
      ...state,
      activeDetailProgram: null,
    }
    return state
  }

  // Case 02: If you do have program information, build a new state out of it.
  const nextState = {
    ...state,
    activateDetailProgram: program,
  }
  nextState.returnMapState = mapState ? { ...mapState, } : null
  nextState.returnLocationFilter = locationFilter ? { ...locationFilter, } : null
  return nextState
}

function resetSearchReturnData (state) {
  return {
    ...state,
    returnLocationFilter : null,
    returnMapState       : null,
  }
}

const searchAppTypes = {
  init                   : 'INIT',
  activateDetailProgram  : 'ACTIVATE_DETAIL_PROGRAM',
  setActiveDetailProgram : 'SET_ACTIVE_DETAIL_PROGRAM',
  resetSearchReturnData  : 'RESET_SEARCH_RETURN_DATA',
}

export const searchAppActions = {
  init                   : function (nextState) { return { type: searchAppTypes.init, payload: nextState, }},
  activateDetailProgram  : function (program, mapState, locationFilter) { return { type: searchAppTypes.activateDetailProgram, payload: { program, mapState, locationFilter, }, }},
  setActiveDetailProgram : function (program) { return { type: searchAppTypes.setActiveDetailProgram, payload: { program, }, }},
  resetSearchReturnData  : function () { return { type: searchAppTypes.resetSearchReturnData, }},
}


function searchAppReducer (state, action) {
  if (!action || !action.type) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('!!!!! SearchAppReducer: Invalid action provided to map reducer: ', action)
    }
    return state
  }
  const { payload, } = action
  switch (action.type) {
  case searchAppTypes.init: return init(payload)
  case searchAppTypes.activateDetailProgram: return activateDetailProgram(state, payload)
  case searchAppTypes.setActiveDetailProgram: return setActiveDetailProgram(state, payload)
  case searchAppTypes.resetSearchReturnData: return resetSearchReturnData(state, payload)
  default: break
  }
  return state
}

export function useSearchAppReducer (initializerArg) {
  const [ state, dispatch, ] = React.useReducer(searchAppReducer, initializerArg, init)
  return [ state, dispatch, ]
}